module.exports = __webpack_public_path__ + "static/media/stripe-create-account_2.9d0fd8c8.png";